module.exports = __webpack_public_path__ + "img/phone.93752999.png";